export const ACCESS_TOKEN = 'access_token';
export const ACCESS_TOKEN_EXPIRE_TIME = 'access_token_expire_time';
export const USER_ID = 'user_id';
export const USER_LANGUAGE = 'user_language';



// WEBPACK FOOTER //
// ./src/constants/localStorageKeys.js